import React from "react";
import * as MdIcons from "react-icons/md";

import { IAlertMessage } from "./alertMessage.d.ts";

import { Container, Content } from "./styles";
/**
 * Componente de mensagem de alerta
 * @param {IAlertMessage} props - Props do componente
 * @returns {JSX.Element} Componente de mensagem de alerta
 **/
const AlertMessage = ({ icons, message, type }) => {
	/**
	 * @type {import("react-icons/lib").IconBaseProps}
	 */
	const IconComponent = MdIcons[icons];

	const configIconColor = {
		success: "#01E59B",
		default: "#01E59B",
		warning: "#F0960F",
		error: "#D30D48",
	};

	return (
		<Container>
			<Content>
				{icons && (
					<IconComponent size={24} color={configIconColor[type || "default"]} />
				)}
				{message}
			</Content>
		</Container>
	);
};

export default AlertMessage;
